import { Link, useSearchParams } from 'react-router-dom';

export default function ModerationPage() {
  const [searchParams] = useSearchParams();
  const communityKey = searchParams.get('community_key') || 'default';

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="rounded-lg border bg-card p-8 shadow-sm">
          <div className="mb-6">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-purple-500/10 text-purple-600 dark:text-purple-400 mb-4">
              MODERATOR ACCESS
            </span>
            <h1 className="text-3xl font-bold mb-2">Content Moderation</h1>
            <p className="text-muted-foreground">
              Review and moderate community content. Community: <span className="font-mono font-semibold">{communityKey}</span>
            </p>
          </div>

          <div className="space-y-4 mb-6">
            <div className="p-4 rounded-md bg-muted/50">
              <h3 className="font-semibold mb-1">Moderation Tools:</h3>
              <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1">
                <li>Review flagged content</li>
                <li>Approve or remove posts</li>
                <li>Manage user reports</li>
                <li>View moderation logs</li>
                <li>Set community guidelines</li>
              </ul>
            </div>

            <div className="p-4 rounded-md border-l-4 border-purple-500 bg-purple-500/5">
              <p className="text-sm font-medium text-purple-900 dark:text-purple-200">
                ✅ You have moderator access for this community.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="p-4 rounded-md border">
                <div className="text-2xl font-bold text-primary mb-1">0</div>
                <div className="text-sm text-muted-foreground">Pending Reports</div>
              </div>
              <div className="p-4 rounded-md border">
                <div className="text-2xl font-bold text-primary mb-1">0</div>
                <div className="text-sm text-muted-foreground">Flagged Posts</div>
              </div>
              <div className="p-4 rounded-md border">
                <div className="text-2xl font-bold text-primary mb-1">0</div>
                <div className="text-sm text-muted-foreground">Actions Today</div>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Link 
              to="/"
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2"
            >
              Back to Home
            </Link>
            <button 
              disabled
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
            >
              View Queue (Coming Soon)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
